import { Component, Input, OnChanges, ElementRef } from '@angular/core';
import { IScriptHistoryService } from '../../common/interfaces/IScriptHistoryService.interface';
import { ScriptConfiguration, ScriptingLanguageType } from '../../cpq-scripting-codemirror/cpq-scripting.model';
import { ScriptHistoryRecord } from '../../common/models/ScriptHistory.model';

@Component({
    selector: 'cpq-script-details',
    templateUrl: './script-details.component.html',
    styleUrls: ['./script-details.component.scss'],
    standalone: false
})
export class ScriptDetailsComponent implements OnChanges {

  @Input('scriptId') scriptId: number;
  @Input('scriptHistoryRecordId') scriptHistoryRecordId: number;
  @Input('scriptHistoryRecordVersionNumber') scriptHistoryRecordVersionNumber: number;
  @Input('scriptHistoryService') scriptHistoryService: IScriptHistoryService;
  @Input('languageType') languageType: ScriptingLanguageType = ScriptingLanguageType.IronPython;

  public model: ScriptHistoryRecord;
  public scriptConfig: ScriptConfiguration = new ScriptConfiguration();
  constructor(public el: ElementRef) { }

  ngOnChanges() {
    if (this.scriptId && this.scriptHistoryRecordId && this.scriptHistoryRecordVersionNumber >= 0 && this.scriptHistoryService) {
      this.scriptHistoryService.getScriptHistoryRecordDetails(this.scriptId, this.scriptHistoryRecordId).subscribe(scriptRecord => {
        this.model = scriptRecord;
        this.model.versionNumber = this.scriptHistoryRecordVersionNumber;
        this.scriptConfig.script = this.model.content;
        this.el.nativeElement.scrollIntoView({ block: 'end',  behavior: 'smooth' });
      });
    }
  }

}
